import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';
import { FiMail, FiLock, FiArrowRight } from 'react-icons/fi';
import logoOgp from '../assets/ogp-logo-blanc.png';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const result = await login(email, password);
    setLoading(false);
    if (result.success) {
      toast.success('Connexion réussie');
      navigate('/');
    } else {
      toast.error(result.error);
    }
  };

  return (
    <div className="login-page">
      {/* Pattern parchemin discret */}
      <div className="login-page-pattern" />

      <div className="login-card">
        <div className="login-card-header">
          <div className="login-badge">
            <img
              src={logoOgp}
              alt="Office Guineen de Publicite"
              className="login-badge-logo"
            />
          </div>
          <h1 className="login-title">Office Guinéen de Publicité</h1>
          <p className="login-subtitle">Gestion des Immobilisations</p>
          <div className="login-divider" />
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="login-field">
            <label>Adresse email</label>
            <div className="login-input-wrap">
              <FiMail className="login-input-icon" />
              <input
                type="email"
                placeholder="votre@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
              />
            </div>
          </div>

          <div className="login-field">
            <label>Mot de passe</label>
            <div className="login-input-wrap">
              <FiLock className="login-input-icon" />
              <input
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />
            </div>
          </div>

          <button type="submit" className="login-submit" disabled={loading}>
            {loading ? 'Connexion en cours…' : (
              <>
                Se connecter
                <FiArrowRight />
              </>
            )}
          </button>
        </form>

        <div className="login-footer">
          <span>Réservé aux agents OGP autorisés</span>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
